<template>
    <div class="technical tac mtw mbw fs1"><i class="iconfont fs1 vam">&#xea76;</i> 技术支持: 滨州伯乐创想电子科技有限公司</div>
</template>
<script>
export default {
    name: 'TheCopyright'
}
</script>


// WEBPACK FOOTER //
// src/components/TheCopyright.vue